import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

interface Props {
  backTo: string;
  backLabel: string;
  objective: string;
  title: string;
  skill?: string;
  duration?: number;
  meta?: ReactNode;
  children: ReactNode;
}

export default function LessonShell({ backTo, backLabel, objective, title, skill, duration, meta, children }: Props) {
  return (
    <div className="bg-warm-50 min-h-screen">
      <div className="bg-white border-b border-ink-100">
        <div className="container-app py-5 flex items-center justify-between gap-4">
          <Link to={backTo} className="inline-flex items-center gap-2 text-sm text-ink-500 hover:text-ink-900">
            <ArrowLeft className="w-4 h-4" /> {backLabel}
          </Link>
          {meta}
        </div>
      </div>

      <div className="container-app py-10 max-w-3xl">
        <div className="text-[11px] uppercase tracking-[0.22em] font-semibold text-ink-500 mb-3">
          Learning objective
        </div>
        <p className="text-lg text-ink-700 leading-relaxed mb-6">{objective}</p>
        <h1 className="font-display text-4xl sm:text-5xl mb-3 leading-tight">{title}</h1>
        <div className="flex flex-wrap items-center gap-3 text-sm text-ink-500 mb-10">
          {skill && (
            <span className="inline-flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-ink-700" /> Skill · {skill}
            </span>
          )}
          {typeof duration === 'number' && (
            <span className="inline-flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-ink-300" /> {duration} min
            </span>
          )}
        </div>

        <div className="space-y-5">{children}</div>
      </div>
    </div>
  );
}
